export default "__VITE_ASSET__gDaHqjc$__"